<template>
	<router-link :to="{ name: routeName, params, query }" class="alert" :class="alertCssClass">
		<spinner v-if="reading.loading" class="spinner"/>
		<div class="details">
			<div class="type">{{ message }}</div>
			<svgicon :name="icon" :fill="false" class="icon-type"></svgicon>
			<div class="info" :class="{ falls: isFalls }" v-html="info"></div>
		</div>
		<div class="details">
			<svgicon name="user" :fill="false" class="icon-user"></svgicon>
			<div class="name">{{ profileName }}</div>
			<div class="date">{{ date }}</div>
			<div class="hour">{{ time }}</div>
		</div>
	</router-link>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import Readings from '@/utils/readings'
import objIsEmpty from '@/utils/objIsEmpty'
export default {
	props: [
		'alert'
	],
	data () {
		return {
			componentName: 'dashboard alert',
			reading: new ApiObject()
		}
	},
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		patient () {
			const watchId = this.alert.args.virtual_watch
			return this.$store.getters.getAccountWatch(this.selectedAccount, watchId)
		},
		profile () {
			return this.patient ? this.patient.profile.data : {}
		},
		type () {
			return Readings.readingTypes.get(parseInt(this.alert.args.type)).name
		},
		message () {
			return this.alert.title.replace('- IDICare', '')
		},
		info () {
			if (!objIsEmpty(this.reading.data)) {
				switch (parseInt(this.alert.args.type)) {
					case Readings.TYPE_BLOOD_PRESSURE:
						return `${this.reading.data.values.systolic_last} ${this.reading.data.values.diastolic_last} ${this.unitHtml}`
					case Readings.TYPE_GEOFENCING:
						let lat = Number.parseFloat(this.reading.data.values.latitude).toFixed(2)
						let lng = Number.parseFloat(this.reading.data.values.longitude).toFixed(2)
						let parts = this.unitHtml.split(' ')
						return `${lat}&nbsp;${parts[0]} ${lng}&nbsp;${parts[1]}`
					case Readings.TYPE_FALLS:
						return this.$t('readings.falls.fall_detected')
					default:
						return `${this.reading.data.values.last} ${this.unitHtml}`
				}
			} else {
				return ''
			}
		},
		unitHtml () {
			return Readings.readingTypes.get(parseInt(this.reading.data.type_id)).unitHtml
		},
		profileName () {
			return this.profile ? this.profile.name : ''
		},
		date () {
			return this.$moment(this.alert.create_time).format('D MMM YYYY')
		},
		time () {
			return this.$moment(this.alert.create_time).format('HH:mm')
		},
		routeName () {
			switch (parseInt(this.alert.args.type)) {
				case Readings.TYPE_GEOFENCING:
					return 'WatchGeofencingAlertViewResumeV2'
				default:
					return 'WatchBiometricAlertViewResumeV2'
			}
		},
		params () {
			return {
				user_uid: this.alert.args.user,
				watch_id: this.alert.args.virtual_watch,
				type: Readings.readingTypes.get(parseInt(this.alert.args.type)).route,
				alert_id: this.alert.args.alert_id
			}
		},
		query () {
			return {
				action: 'update'
			}
		},
		alertCssClass () {
			switch (parseInt(this.alert.args.urgency)) {
				case 1:
					return 'urgency-min'
				case 2:
					return 'urgency-med'
				case 3:
					return 'urgency-max'
				default:
					return ''
			}
		},
		icon () {
			return Readings.readingTypes.get(parseInt(this.alert.args.type)).icon
		},
		isFalls () {
			return this.alert.args.type === Readings.TYPE_FALLS
		}
	},
	methods: {
		getReading () {
			const user_uid = this.alert.args.user
			const watch_id = this.alert.args.virtual_watch
			const type_id = this.alert.args.type
			const reading_id = this.alert.args.reading.id
			this.reading.loading = true
			this.reading.data = {}
			this.$api.readings.getByID(this, user_uid, watch_id, type_id, reading_id)
				.then(response => {
					this.$log.info('alert reading', 'readings.getByID OK', response)()
					this.reading.data = response.body
				})
				.catch(error => {
					this.$log.error('alert reading', 'readings.getByID ERROR', error)()
					this.reading.error = error
				})
				.finally(() => {
					this.reading.loading = false
				})
		}
	},
	mounted () {
		this.getReading()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/components/AlertsWidgetAlert.vue